// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_auth_session-timeout_service_ts":"fa479c06d9ea3f89","node_modules_html2canvas_dist_html2canvas_js":"97d5258182e77700","node_modules_dompurify_dist_purify_es_mjs":"26193428cf90adf5","node_modules_canvg_lib_index_es_js":"cbe1e10e2bd82f8a"}[chunkId] + ".js";
};